<script lang="ts">
	import { Container, Icon, Modal, Text, Button } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import type { DashWidgetEditType } from '../dash-types';
	import { requestDeleteDashboardWidget } from '../dash-helpers';
	import { params } from 'svelte-spa-router';
	import { createEventDispatcher } from 'svelte';
	import { createAsyncAction } from 'src/helpers/async_action_guard';

	export let editItem: DashWidgetEditType;
	export let showModal = false;

	const dispatch = createEventDispatcher();
	const { loading: deleteLoading, run: runDelete } = createAsyncAction();

	const onCloseModal = () => {
		showModal = false;
	};

	const onDeleteCard = () =>
		runDelete(async () => {
			let dashIdFromRoute = $params.id;
			await requestDeleteDashboardWidget({ ...editItem, dashboardId: dashIdFromRoute });
			dispatch('delete-widget-finish', { id: editItem.id });
			onCloseModal();
		});

	$: noWidgetTitle = !editItem.widgetTitle || (editItem.widgetTitle && !editItem.showWidgetTitle);
</script>

<Modal
	on:close={onCloseModal}
	{showModal}
	title={$format('prompt_title_delete_widget', { default: 'Delete widget?' })}
>
	<Container slot="content" padding="0">
		<div class="d-flex flex-direction-column align-items-center">
			<Icon size="xxl" icon="fa-light fa-trash" class="text-danger mb-xs" />
			{#if !noWidgetTitle}
				<Text class="text-bold text-center mb-s" styleType="controls-large">
					{editItem.widgetTitle}
				</Text>
			{/if}

			<Text class="width-full">
				{#if noWidgetTitle}
					{$format('label_delete_widget_remove_from_dash', {
						default: `Deleting this widget will remove it from your dashboard.`,
					})}
				{:else}
					{$format('on_delete_widget_msg', {
						values: {
							device_name: editItem.widgetTitle,
						},
						default: `Deleting widget ‘{device_name}’ will remove it from your dashboard.`,
					})}
				{/if}
			</Text>
		</div>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onCloseModal}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			loading={$deleteLoading}
			on:click={onDeleteCard}
		>
			{$format('button_delete_widget', { default: 'Delete widget' })}
		</Button>
	</div>
</Modal>
